import { useMemo, useState } from 'react';
import { optimizeBuilding } from '../../../engine/buildingOptimizer';

export function BuildingOptimizer() {
  const [energy, setEnergy] = useState(1200);
  const [water, setWater] = useState(800);
  const [temp, setTemp] = useState(24);
  const [out, setOut] = useState(12);
  const [occ, setOcc] = useState(0.6);
  const [price, setPrice] = useState(0.23);

  const rec = useMemo(() => optimizeBuilding({ energy_kWh: energy, water_liters: water, temp_celsius: temp, outsideTemp: out, occupancyLevel: occ, energyPriceEurPerKWh: price }), [energy, water, temp, out, occ, price]);

  return (
    <div className="space-y-3">
      <div className="font-orbitron text-evat-gold">Building Optimizer</div>
      <div className="grid grid-cols-2 md:grid-cols-6 gap-2 text-sm">
        <label className="flex items-center gap-2">Energy
          <input type="number" value={energy} onChange={(e)=>setEnergy(Number(e.target.value))} className="bg-black border border-evat-neon text-evat-neon px-2 py-1 rounded w-24"/>
        </label>
        <label className="flex items-center gap-2">Water
          <input type="number" value={water} onChange={(e)=>setWater(Number(e.target.value))} className="bg-black border border-evat-neon text-evat-neon px-2 py-1 rounded w-24"/>
        </label>
        <label className="flex items-center gap-2">Temp
          <input type="number" value={temp} onChange={(e)=>setTemp(Number(e.target.value))} className="bg-black border border-evat-neon text-evat-neon px-2 py-1 rounded w-20"/>
        </label>
        <label className="flex items-center gap-2">Outside
          <input type="number" value={out} onChange={(e)=>setOut(Number(e.target.value))} className="bg-black border border-evat-neon text-evat-neon px-2 py-1 rounded w-20"/>
        </label>
        <label className="flex items-center gap-2">Occupancy
          <input type="number" step="0.1" min="0" max="1" value={occ} onChange={(e)=>setOcc(Number(e.target.value))} className="bg-black border border-evat-neon text-evat-neon px-2 py-1 rounded w-20"/>
        </label>
        <label className="flex items-center gap-2">€/kWh
          <input type="number" step="0.01" value={price} onChange={(e)=>setPrice(Number(e.target.value))} className="bg-black border border-evat-neon text-evat-neon px-2 py-1 rounded w-20"/>
        </label>
      </div>
      <div className="border border-neutral-700 rounded p-3">
        <div className="text-neutral-300">HVAC: <span className="text-evat-neon">{rec.hvacAdjustment}</span></div>
        <div className="text-neutral-300">Light dim: <span className="text-evat-gold">{rec.lightDimPercent}%</span></div>
        <div className="text-neutral-300">Water: <span className="text-evat-neon">{rec.waterPolicy}</span></div>
        <div className="text-neutral-400 text-sm mt-2">Estimated savings: <span className="text-evat-gold">{rec.estimatedCo2SavedKg} kg CO2</span> • <span className="text-evat-neon">€{rec.estimatedCostSavedEur}</span></div>
      </div>
    </div>
  );
}

export default BuildingOptimizer;












